import moment from 'moment'
import { validateDate, validateTime } from '../lib/validations'

export const MEAL_NAME_VALUES = ['Lunch', 'Afternoon Tea']

const EMPTY_REPLACEMENTS = {
  date: null,
  time: 'TBC'
}

const isInitted = (originalData, attributeName, value) => {
  return originalData[attributeName] !== value
}

const isUpdated = (originalData, attributeName, value) => {
  return isInitted(originalData, attributeName, value) && originalData[attributeName] !== EMPTY_REPLACEMENTS[attributeName]
}

export default class LunchTime {
  constructor (item, index) {
    this.id = index
    this.minDate = moment(item.booking_travel_date)
    this.maxDate = moment(item.booking_return_date)
    this.lunchTime = item.lunch_times[this.id]
    this.originalData = item.originalData.lunch_times[this.id]

    this.lunchTime.original_date = this.originalData.date
    this.lunchTime.original_time = this.originalData.time
    this.lunchTime.original_meal_name = this.originalData.meal_name
  }

  update (attributeName, value) {
    if (value === '') {
      value = EMPTY_REPLACEMENTS[attributeName]
    }

    this.lunchTime[attributeName] = value
    this.lunchTime.invalid = !this.isValid()
    this.lunchTime.updated = isUpdated(this.originalData, attributeName, value)
    this.lunchTime.initted = isInitted(this.originalData, attributeName, value)

    return value
  }

  validateMealName () {
    if (MEAL_NAME_VALUES.includes(this.lunchTime.meal_name)) {
      return {}
    }
    return { lunch_times: { [this.id]: { meal_name: ['invalid'] } } }
  }

  validate () {
    return {
      ...validateTime(this.id, this.lunchTime.time, 'lunch_times', true),
      ...validateDate(this.id, this.lunchTime.date, this.minDate, this.maxDate, 'lunch_times', true),
      ...this.validateMealName()
    }
  }

  isValid () {
    const errors = {
      ...this.validate()
    }

    return !Object.keys(errors).length > 0
  }
}
